import { render, staticRenderFns } from "./CourseReviewPanel.vue?vue&type=template&id=0f12881f&scoped=true"
import script from "./CourseReviewPanel.vue?vue&type=script&lang=js"
export * from "./CourseReviewPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseReviewPanel.vue?vue&type=style&index=0&id=0f12881f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12881f",
  null
  
)

export default component.exports